import { useApiMutation } from '@/hooks/useApiMutation';
import { apiPost, operationsClient } from '@/lib/api/client';
import { companyCamEndpoints } from '@/lib/api/endpoints';

interface AuthorizeUrlResponse {
  url: string;
}

/**
 * Returns the CompanyCam OAuth authorization URL; the caller redirects to it.
 *
 * POST rather than GET (the QuickBooks shape) because the server mints a
 * signed, single-use `state` on every call — that is a write, and caching it
 * would hand two browser tabs the same nonce.
 */
export function useConnectCompanyCam() {
  return useApiMutation<AuthorizeUrlResponse, void>({
    mutationFn: () =>
      apiPost<AuthorizeUrlResponse>(
        operationsClient,
        companyCamEndpoints.authorizeUrl(),
      ),
  });
}
